/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */
import {MutationTree} from 'vuex';
import {UserSessionInterface, UserSessionStateInterface} from '@/store/modules/user-session/types';
import {Vue} from 'vue-property-decorator';

/**
 * User session mutations.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const mutations: MutationTree<UserSessionStateInterface> = {
    /**
     * Logout of user session.
     *
     * @param {UserSessionStateInterface} state
     */
    logout(state: UserSessionStateInterface): void {
        Vue.set(state.session, 'token', '');
        Vue.set(state.session, 'expiry', 0);
    },


    /**
     * Authenticate user session.
     *
     * @param {UserSessionStateInterface} state
     * @param {UserSessionInterface} session
     */
    authenticate(state: UserSessionStateInterface, session: UserSessionInterface): void {
        Vue.set(state.session, 'token', session.token);
        Vue.set(state.session, 'expiry', session.expiry);
    },
};
